<section class="cmn-innerpage-wrapper accommodation">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>

    <div class="form-wrapper" style="padding-top: 10px">
      <form [formGroup]="dateRangeForm">
        <mat-form-field>
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              placeholder="Start date"
              formControlName="startDate"
              (dateInput)="onDateChange($event, 'start')"
            />
            <input
              matEndDate
              placeholder="End date"
              formControlName="endDate"
              (dateInput)="onDateChange($event, 'end')"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </form>
    </div>
    <div>
      <h6 class="cmn-popup-heading" (click)="onClear()">
        <span>Clear&nbsp;Filter</span>
      </h6>
    </div>
    <button
      class="cmn-add-btn"
      (click)="navigateTo('accommodation/accommodation-log')"
      *ngIf="canViewLogsAllocations$ | async"
    >
      View Log
    </button>
  </div>
  <div *ngIf="canListAllocations$ | async">
    <div class="inner-content">
    <div class="acommodation-detail-header">
      <p class="cmn-title">Employee Allocation List</p>
      <p (click)="openAddDialog()" class="allocate-employee-section" *ngIf="canAllocateAllocations$ | async">
        Allocate Employee
        <img
          src="assets/images/icons/allocate-employee.svg"
          alt="Employee Allocate"
        />
      </p>
    </div>

    <div class="common-noimage-tab-wrapper">
      <mat-tab-group animationDuration="0ms">
        <!-- Mat Tab One -->
        <mat-tab>
          <ng-template mat-tab-label>
            <h2 class="accommodation-tab-title">Ongoing</h2>
          </ng-template>
          <div class="accommodation-details-table">
            <table *ngIf="employeeData?.length">
              <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="account-detail-row"
                  *ngFor="let data of employeeData"
                >
                  <td class="title">
                    <div>
                      <img
                        src="assets/images/icons/icon-personal-plain.svg"
                        alt="Employee Name"
                      />{{ data?.employeeName || "--" }}
                    </div>
                  </td>
                  <td>
                    {{ (data?.startDate | date : "dd MMM yyyy") || "--" }}
                  </td>
                  <td>{{ (data?.endDate | date : "dd MMM yyyy") || "--" }}</td>
                  <td>
                    <div class="mat-menu-wrapper" *ngIf="(canReleaseAllocations$ |async) || (canEditAllocations$ | async)">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button
                          mat-menu-item
                          (click)="openEditDialog(data, false)"
                          *ngIf="canEditAllocations$ | async"
                        >
                          <span>Edit</span>
                        </button>
                        <button
                          mat-menu-item
                          (click)="openEditDialog(data, true)"
                          *ngIf="canReleaseAllocations$ | async"
                        >
                          <span>Release Employee</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="no-active-employees" *ngIf="employeeData?.length === 0">
              <p>No active employees allocated</p>
            </div>
          </div>
        </mat-tab>
        <!-- Mat Tab Two -->
        <mat-tab>
          <ng-template mat-tab-label>
            <h2 class="accommodation-tab-title">Upcoming</h2>
          </ng-template>
          <div class="accommodation-details-table">
            <table *ngIf="upcomingEmployeeData?.length">
              <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="account-detail-row"
                  *ngFor="let data of upcomingEmployeeData"
                >
                  <td class="title">
                    <div>
                      <img
                        src="assets/images/icons/icon-personal-plain.svg"
                        alt="Employee Name"
                      />{{ data?.employeeName || "--" }}
                    </div>
                  </td>
                  <td>
                    {{ (data?.startDate | date : "dd MMM yyyy") || "--" }}
                  </td>
                  <td>{{ (data?.endDate | date : "dd MMM yyyy") || "--" }}</td>
                  <td>
                    <div class="mat-menu-wrapper" *ngIf="(canReleaseAllocations$ |async) || (canEditAllocations$ | async)">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button
                          mat-menu-item
                          (click)="openEditDialog(data, false)"
                          *ngIf="canEditAllocations$ | async"
                        >
                          <span>Edit</span>
                        </button>
                        <button
                          mat-menu-item
                          (click)="openEditDialog(data, true)"
                          *ngIf="canReleaseAllocations$ | async"
                        >
                          <span>Release Employee</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="no-active-employees"
              *ngIf="upcomingEmployeeData?.length === 0"
            >
              <p>No active employees allocated</p>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="pagination-wrapper">
    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select
        id="pageSize"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange($event)"
      >
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="page-nav" *ngIf="totalPages > 1">
      <button class="prev" (click)="prevPage()" [disabled]="page === 0">
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="prev arrow"
          srcset=""
        />
      </button>
      <span> Page {{ page + 1 }} of {{ totalPages }} </span>
      <button
        class="next"
        (click)="nextPage()"
        [disabled]="page + 1 >= totalPages"
      >
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="next arrow"
          srcset=""
        />
      </button>
    </div>
  </div>
  </div>
</section>
